var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFiletypeAmim(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm11 3v-3h-9v16h12v-13z', fill: '#41bdc6' }),
        React.createElement("path", { d: 'm6.68263 12.17714-2.68263.82286.67066-2.56 4.024-4.11429 2.012 1.73715zm5.17366-5.30285-.86228.91428-2.01201-1.73714.95808-.91429a.47854.47854 0 0 1 .67066 0l1.24551 1.09715a.42813.42813 0 0 1 .00004.64z', fill: '#fff' }),
        React.createElement("path", { d: 'm11 0 3 3h-3z', fill: '#32848a' })));
}
export default SvgFiletypeAmim;
